import { DirectionsBoat, Info, LocalShipping } from '@mui/icons-material'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { M_DrawerTableTextField, M_Fieldset, M_FormFavorites, M_InputTextField, M_Select } from 'src/M_Components'

const changes = (field, value, setData) => {
    setData(prev => ({ ...prev, [field]: value }))
}

const transportStateOptions = [
    { value: 'Archive', label: 'Archive' },
    { value: 'Account', label: 'Account' },
    { value: 'Preview', label: 'Preview' },
    { value: 'Open', label: 'Open' },
    { value: 'Locked', label: 'Locked' },
    { value: 'Transfer Block', label: 'Transfer Block' },
]

export const TransportInfo = ({ dataState, setDataState, isView = false }) => {
    const { t } = useTranslation()

    const transportVarNameDict = useMemo(() => new Map([
        ['TradeCode',    dataState?.TradeCode    || ''],
        ['TradeId',      dataState?.TradeId      || ''],
        ['VoyageNumber', dataState?.VoyageNumber || ''],
        ['VoyageId',     dataState?.VoyageId     || ''],
    ]), [dataState?.TradeCode, dataState?.TradeId, dataState?.VoyageNumber, dataState?.VoyageId])

    return (
    <M_FormFavorites
        entityName="Transport"
        pageUrl="Transport"
        varNameDict={transportVarNameDict}
        setVarNameDict={() => {}}
        onFavoriteLoad={(loadedData) => {
            setDataState(prev => ({ ...prev, ...loadedData }))
        }}
        onAfterApply={() => {}}
    >
        <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
            <M_Fieldset
                labelInside
                label={
                    <div style={{ display: 'flex', alignItems: 'center', fontSize: '25px', marginLeft: '10px' }}>
                        <LocalShipping style={{ marginRight: '10px', scale: '1.3' }} />
                        {t('TransportService')}
                    </div>
                }
                elements={
                    <div style={{ display: 'flex', flexWrap: 'wrap', width: '100%' }}>
                        <div style={{ margin: '5px' }}>
                            <M_DrawerTableTextField
                                size="250px"
                                label={t('TradeCode')}
                                tableLabel="Trade"
                                entity="Trade"
                                filterField="TradeCode"
                                labelFields={['TradeCode']}
                                required={!isView}
                                disabled={isView}
                                color={!isView && !dataState?.TradeId ? 'var(--color-red)' : undefined}
                                secondColor={!isView && !dataState?.TradeId ? 'var(--color-red)' : undefined}
                                value={dataState?.TradeId
                                    ? {
                                        Id: dataState.TradeId,
                                        TradeCode: dataState.TradeCode,
                                        TradeLineCode: dataState.TradeLineCode,
                                        TradeName: dataState.TradeName,
                                        TradeBound: dataState.TradeBound,
                                    }
                                    : null
                                }
                                onSubmitValue={(obj) => {
                                    if (isView) return
                                    setDataState(prev => ({
                                        ...prev,
                                        TradeId: obj?.Id || '',
                                        TradeCode: obj?.TradeCode || '',
                                        TradeLineCode: obj?.TradeLineCode || '',
                                        TradeName: obj?.TradeName || '',
                                        TradeBound: obj?.TradeBound ?? '',
                                    }))
                                }}
                                favoritesFieldName={t('TradeCode')}
                                favoritesGroupName="Transport"
                                favoritesVarKey="TradeCode"
                                favoritesIdKey="TradeId"
                            />
                        </div>
                        <div style={{ margin: '5px' }}>
                            <M_InputTextField
                                size="250px"
                                disabled
                                label={t('LineCode')}
                                value={dataState?.TradeLineCode || ''}
                            />
                        </div>
                        <div style={{ margin: '5px' }}>
                            <M_InputTextField
                                size="250px"
                                disabled
                                label={t('TradeName')}
                                value={dataState?.TradeName || ''}
                            />
                        </div>
                        <div style={{ margin: '5px' }}>
                            <M_InputTextField
                                size="250px"
                                disabled
                                label={t('TradeBound')}
                                value={dataState?.TradeBound || ''}
                            />
                        </div>
                    </div>
                }
            />

            <M_Fieldset
                labelInside
                label={
                    <div style={{ display: 'flex', alignItems: 'center', fontSize: '25px', marginLeft: '10px' }}>
                        <DirectionsBoat style={{ marginRight: '10px', scale: '1.3' }} />
                        {t('Voyage')}
                    </div>
                }
                elements={
                    <div style={{ display: 'flex', flexWrap: 'wrap', width: '100%' }}>
                        <div style={{ margin: '5px' }}>
                            <M_DrawerTableTextField
                                size="250px"
                                label={t('Voyage')}
                                tableLabel="Voyages"
                                entity="Voyage"
                                filterField="VoyageNumber"
                                labelFields={['VoyageNumber', 'VesselCode', 'VesselName']}
                                required={!isView}
                                disabled={isView}
                                color={!isView && !dataState?.VoyageId ? 'var(--color-red)' : undefined}
                                secondColor={!isView && !dataState?.VoyageId ? 'var(--color-red)' : undefined}
                                value={dataState?.VoyageId
                                    ? { Id: dataState.VoyageId, VoyageNumber: dataState.VoyageNumber }
                                    : null
                                }
                                onSubmitValue={(obj) => {
                                    if (isView) return
                                    setDataState(prev => ({
                                        ...prev,
                                        VoyageId: obj?.Id || '',
                                        VoyageNumber: obj?.VoyageNumber || '',
                                        VesselCode: obj?.VesselCode || '',
                                        VesselName: obj?.VesselName || '',
                                    }))
                                }}
                                favoritesFieldName={t('Voyage')}
                                favoritesGroupName="Transport"
                                favoritesVarKey="VoyageNumber"
                                favoritesIdKey="VoyageId"
                            />
                        </div>
                        <div style={{ margin: '5px' }}>
                            <M_InputTextField
                                size="250px"
                                disabled
                                label={t('VesselCode')}
                                value={dataState?.VesselCode || ''}
                            />
                        </div>
                        <div style={{ margin: '5px' }}>
                            <M_InputTextField
                                size="250px"
                                disabled
                                label={t('VesselName')}
                                value={dataState?.VesselName || ''}
                            />
                        </div>
                    </div>
                }
            />

            <M_Fieldset
                labelInside
                label={
                    <div style={{ display: 'flex', alignItems: 'center', fontSize: '25px', marginLeft: '10px' }}>
                        <Info style={{ marginRight: '10px', scale: '1.3' }} />
                        {t('TransportDetails')}
                    </div>
                }
                elements={
                    <div style={{ display: 'flex', flexWrap: 'wrap', width: '100%' }}>
                        <div style={{ margin: '5px' }}>
                            <M_InputTextField
                                size="250px"
                                type="date"
                                label={t('TransportDate')}
                                disabled={isView}
                                value={dataState?.TransportDate || ''}
                                onChange={(e) => changes('TransportDate', e.target.value, setDataState)}
                            />
                        </div>
                        <div style={{ margin: '5px' }}>
                            <M_InputTextField
                                size="250px"
                                type="date"
                                label={t('TransportExchange')}
                                disabled={isView}
                                value={dataState?.TransportExchange || ''}
                                onChange={(e) => changes('TransportExchange', e.target.value, setDataState)}
                            />
                        </div>
                        <div style={{ margin: '5px' }}>
                            <M_Select
                                label={t('TransportState')}
                                value={dataState?.TransportState ?? ''}
                                options={transportStateOptions}
                                required={!isView}
                                disabled={isView}
                                hasNone={!isView}
                                color={!isView && !dataState?.TransportState ? 'var(--color-red)' : undefined}
                                secondColor={!isView && !dataState?.TransportState ? 'var(--color-red)' : undefined}
                                onChange={(e) => changes('TransportState', e.target.value, setDataState)}
                                minWidth="250px"
                            />
                        </div>
                        <div style={{ margin: '5px' }}>
                            <M_InputTextField
                                size="250px"
                                label={t('TransportAccounting')}
                                disabled={isView}
                                value={dataState?.TransportAccounting || ''}
                                onChange={(e) => changes('TransportAccounting', e.target.value, setDataState)}
                            />
                        </div>
                        <div style={{ margin: '5px', flexBasis: '100%' }}>
                            <M_InputTextField
                                size="600px"
                                label={t('TransportComments')}
                                disabled={isView}
                                value={dataState?.TransportComments || ''}
                                onChange={(e) => changes('TransportComments', e.target.value, setDataState)}
                            />
                        </div>
                    </div>
                }
            />
        </div>
    </M_FormFavorites>
    )
}
